import styled from 'styled-components';

export const Container = styled.div`
	width: 100%;
	padding: 16px 0px;

	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: 16px;

	img {
		width: 100%;
		object-fit: cover;
		border-radius: 12px;
	}
`;

export const Contents = styled.div`
	width: 100%;
	padding: 0px 20px;

	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: 24px;
`;

export const TextContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: 4px;
`;

export const PriceWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	gap: 8px;
`;

export const ButtonWrapper = styled.div`
	width: 100%;
	padding: 30px 24px;

	display: flex;
	justify-content: center;
	align-items: center;

	button {
		width: 100%;
		padding: 12px 20px;
		border-radius: 6px;

		display: flex;
		justify-content: center;
		align-items: center;
		border: none;
		background-color: ${({ theme }) => theme['orange-primary']};
	}
`;

export const Header = styled.div`
	width: 100%;
	max-width: 768px;
	height: 48px;

	position: relative;
	box-sizing: border-box;
	padding: 12px 40px;

	display: flex;
	justify-content: center;
	align-items: center;
	background-color: ${({ theme }) => theme['white-primary']};
`;

export const BackIconWrapper = styled.div`
	width: 24px;
	height: 24px;
	position: absolute;
	left: 20px;

	svg {
		width: 24px;
		height: 24px;
		cursor: pointer;

		path {
			fill: ${({ theme }) => theme['brown-primary']};
		}
	}
`;
